import React from 'react';
import ReactDOM, { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import * as v3d from 'verge3d';
import App from './App';
import Annotation from './components/Annotation';
import './index.css';
import reportWebVitals from './reportWebVitals';
import useLayersStore, { DEFAULT_FEATURE_ENABLED } from './stores/layersStore';

function receiveMessage(event) {
  console.log('receiveMessage', event);
  if (!event.data){

    console.log('returning no event data recived');
    return;
  }
  if (event.origin.includes('localhost')) {
    console.log("origin is localhost returning");
    return;
  }
  if (typeof event.data != 'string'){
    console.log("returning because event isn't string: ", typeof event.data);
    return;
  }
  const dataEv = JSON.parse(event.data);
  const { customDomain } = dataEv;
  const customDomainUrl = customDomain && !customDomain.startsWith('https://') ? `https://${customDomain}` : customDomain;
  console.log('origin: ', event.origin,' customDomain: ', customDomain, ' customDomainUrl:', customDomainUrl);
  if (
    ![
      'https://portal.biocloud3d.com',
      'https://portal.biocloud3d.dev',
      'https://dev.biocloud3d.com',
      customDomainUrl,
    ].includes(event.origin)
  ) {
    console.log('Origin not allowed: ', event.origin);
    return;
  }
  useLayersStore.getState().setBranding(dataEv.branding);
  
  if (dataEv.featureEnabled) {
    console.log('Setting featureEnabled from message:', dataEv.featureEnabled);
    useLayersStore.getState().setFeatureEnabled(dataEv.featureEnabled);
  }

  //temporary global for biocloud3d.com homepage embed.
  window.EMBED_MODEL_ID = dataEv.modelId;

  // Embedding Mode
  if (false) {
    (async () => {
      if (dataEv.success === true) {
        doStyleUpdatesandShowModel(dataEv);
      }
    })();
    return;
  } else {
    // Standard Mode
    const isDev = window.location.hostname.includes('dev') || window.location.hostname === 'localhost';
    const apiBaseUrl = isDev ? 'https://biocloud3d.dev:8080' : 'https://api.biocloud3d.com:8080';
    const url = `${apiBaseUrl}/api/model/detail`;

    const data = {
      modelToken: dataEv.user.modelToken,
      modelId: dataEv.modelId,
      userId: dataEv.user.id,
    };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    })
      .then(response => response.json())
      .then(result => {
        if (result.error === null) {
          loadBranding(dataEv);
        }
      })
      .catch(error => console.error('There was an error fetching the resource', error));
  }
}

function loadBranding(dataEv) {
  console.log('loadBranding', dataEv);
  const { branding } = dataEv;
 
 /*  let branding = useLayersStore.getState().branding || {};
  let branding_updated = false;
  console.log("DEBUG -- branding in index from LayersStore: ", branding);
  console.log("DEBUG -- branding in index from messageEvent: ", dataEv.branding);
  if (branding != dataEv.branding) {
    useLayersStore.getState().setBranding(dataEv.branding);
    branding = dataEv.branding;
    branding_updated = true;
    console.log("DEBUG -- setBranding was called to update the LayerStore!!!");
  } */

  const bgLogo = document.getElementById('v3d-branding-container');
  let waitingForBackground = false;
  let backgroundLoaded = false;
  let waitingForLoadingLogo = false;
  let loadingLogoLoaded = false;
  let appInitialized = false;

  console.log("DEBUG -- index Logout bgLogo element AFTER new set: ", bgLogo);
  console.log("DEBUG -- index Logout Branding, backgroundColor: ", branding.backgroundColor);
  console.log("DEBUG -- index Logout Branding, backgroundLogo: ", branding.backgroundLogo);
  console.log("DEBUG -- index Logout Branding, loadingLogo: ", branding.loadingLogo);
  console.log("DEBUG -- index Logout Branding, primaryColor: ", branding.primaryColor);

  if (branding.backgroundLogo) {
    waitingForBackground = true;
    let img = new Image();
    img.crossOrigin = 'anonymous'; // Now that CORS is configured, we can use this
    img.onload = function () {
      backgroundLoaded = true;
      // Convert image to data URL for screenshots (now that CORS is fixed)
      try {
        console.log('Image loaded, attempting to convert to data URL. Image dimensions:', img.width, 'x', img.height);
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        console.log('Data URL created successfully, length:', dataURL.length);
        
        // Store the data URL in the branding object
        const currentBranding = useLayersStore.getState().branding;
        const updatedBranding = { 
          ...currentBranding, 
          backgroundLogoDataURL: dataURL 
        };
        
        useLayersStore.getState().setBranding(updatedBranding);
        
        // Verify it was stored
        const verifyBranding = useLayersStore.getState().branding;
        console.log('Background logo data URL stored:', !!verifyBranding.backgroundLogoDataURL);
      } catch (error) {
        console.error('Failed to convert background logo to data URL:', error);
        // Continue anyway - the image still displays fine
      }
    };
    img.onerror = function(error) {
      console.error('Failed to load background image:', error);
      backgroundLoaded = true; // Set to true so we don't wait forever
    };
    img.src = branding.backgroundLogo;
  }

  if (branding.loadingLogo) {
    waitingForLoadingLogo = true;
    let img = new Image();
    img.onload = function () {
      loadingLogoLoaded = true;
    };
    img.src = branding.loadingLogo;
  } 

  const interval = setInterval(function () {
    console.log(
      'waitingForBackground', waitingForBackground, backgroundLoaded,
      'waitingForLoadingLogo', waitingForLoadingLogo, loadingLogoLoaded
    );
    if (waitingForBackground === backgroundLoaded && waitingForLoadingLogo === loadingLogoLoaded) {
      if (!appInitialized) {
        console.log('Branding image load Success! Now rendering App');
        clearInterval(interval);
        appInitialized = true;
        initializeApp();
      }
    }
  }, 100);

  setTimeout(() => {
    if (!appInitialized) {
      console.log('Branding image load timeout reached, rendering App');
      clearInterval(interval);
      appInitialized = true;
      initializeApp();
    }
  }, 5000); // 5 second timeout fallback
}

document.getElementById('root').innerHTML = '<div style="display: flex; justify-content: center; align-items: center; height: 100vh;">Loading...</div>';
const stored_branding = useLayersStore.getState().branding || {}
console.log("DEBUG -- index Logout stored_branding: ", stored_branding);
if (typeof window !== 'undefined') {
  console.log('addEventListener message');
  window.addEventListener('message', receiveMessage, false);
}
const urlParams = new URLSearchParams(window.location.search);
const modelParam = urlParams.get('model');
const path = '/3d/' + modelParam;
const annoConfigResponse = await fetch(`${path}/anno-config.json`);
if (!annoConfigResponse.ok) {
  throw new Error('Failed to load annotation config');
}
console.log(annoConfigResponse.body);
const annoConfig = await annoConfigResponse.json();

const biocloudGeneratorConfigResponse = await fetch(`${path}/biocloud-generator-config.json`);
if (!biocloudGeneratorConfigResponse.ok) {
  throw new Error('Failed to generator annotation config');
}
const biocloudGeneratorConfig = await biocloudGeneratorConfigResponse.json();
useLayersStore.getState().setBiocloudGeneratorConfig(biocloudGeneratorConfig);

function initializeApp() {
  ReactDOM.render(<App />, document.getElementById('root'));

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

  reportWebVitals();

  // Initialize animations in the store
  useLayersStore.getState().setAnimations([]);
  useLayersStore.getState().setCurrentAnimation(null);
  useLayersStore
    .getState()
    .setLayers(Array.from({ length: biocloudGeneratorConfig.layersCount }, (_, i) => i));
  useLayersStore.getState().setLayerPrefix(biocloudGeneratorConfig.layerPrefix);
  console.log(useLayersStore.getState().animationAudios, 4567846);
  let audios = [];
  biocloudGeneratorConfig.animationAudios?.forEach(url => {
    const audio = new Audio(`${path}/${url}`);
    audio.loop = true;
    audio.load(); // Preload the audio
    audios.push(audio);
  });
  useLayersStore.getState().setAnimationAudios(audios);
  // Add this after initializing the store and before v3dApp initialization
  // Use animations from the store

  const v3dApp = new v3d.App('v3d-container');
  useLayersStore.getState().setV3dApp(v3dApp);

  v3dApp.clearBkgOnLoad = true;
  v3dApp.renderer.setClearColor(0x000000, 0);
  console.log(biocloudGeneratorConfig);
  useLayersStore.getState().setAnimationInfos(biocloudGeneratorConfig.animationsPack);

  // Add these constants at the top with other constants
  const annotationContainer = document.getElementById('v3d-anno-container');

  // Update the onProgress function
  const onProgress = progressPercents => {
    useLayersStore.getState().setLoadingProgress(progressPercents);
  };

  v3dApp.loadScene(
    `${path}/model.gltf${biocloudGeneratorConfig.disableCompressedAssets ? '' : '.xz'}`,
    (scene, teszt1, test2) => {
      setTimeout(() => {
        useLayersStore.getState().setIsLoading(false);
      }, 2000);

      // Get the camera from the scene
      useLayersStore.getState().fitScene();

      // Add this function to fit the model to the viewport
      const fitCameraToModel = () => {
        const box = new v3d.Box3().setFromObject(scene);
        const size = box.getSize(new v3d.Vector3());
        const center = box.getCenter(new v3d.Vector3());

        const cameraDistance = Math.max(size.x, size.y, size.z) * 1.5; // Adjust the multiplier as needed
        v3dApp.camera.position.copy(center);
        v3dApp.camera.position.z += cameraDistance; // Move the camera back
        v3dApp.camera.lookAt(center); // Look at the center of the model
      };

      fitCameraToModel(); // Call the function to fit the camera

      v3dApp.enableControls();
      // Disable WASD controls
      v3dApp.controls.enableKeys = false;

      // Add auto-rotation
      v3dApp.controls.autoRotate = true;
      v3dApp.controls.autoRotateSpeed = 2.0; // Adjust speed as needed

      // Add event listeners to stop auto-rotation on user interaction
      v3dApp.controls.addEventListener('start', function () {
        v3dApp.controls.autoRotate = false;
      });

      v3dApp.run();
      scene.traverse(function (obj) {
        var groupNames = obj.groupNames;
        if (!groupNames) return;
        for (var i = 0; i < groupNames.length; i++) {
          var groupName = groupNames[i];
          console.log(groupName);
        }
        function getAnimations(objSelector) {
          const objName = objSelector;
          console.log(objName);
          const action = v3d.SceneUtils.getAnimationActionByName(v3dApp, objName);
          if (action) {
            // Update the store's animations array
            const currentAnimations = useLayersStore.getState().animations;
            useLayersStore.getState().setAnimations([...currentAnimations, objName]);
          }
          return useLayersStore.getState().animations;
        }
        getAnimations(obj.name);
      });

      operateAnimation(
        'PAUSE',
        useLayersStore.getState().animations,
        null,
        null,
        'AUTO',
        1,
        function () {},
        false
      );

      // Auto-start animation if featureEnabled.animate is true
      if (useLayersStore.getState().featureEnabled.animate) {
        console.log('Auto-starting animation');
        // If there's an animationsPack, use the first one, otherwise just play all animations
        if (biocloudGeneratorConfig.animationsPack?.length > 0) {
          useLayersStore.getState().setCurrentAnimation(biocloudGeneratorConfig.animationsPack[0]);
        } else {
          // Play all animations directly
          operateAnimation(
            'PLAY',
            useLayersStore.getState().animations,
            null,
            null,
            'LoopRepeat',
            1,
            function () {},
            false
          );
        }
      }

      // Add annotation setup after camera setup
      setupAnnotations(scene);
    },
    onProgress
  );

  useLayersStore.subscribe(
    // (state) => state.currentAnimation,
    (currentState, previousState) => {
      if (currentState.currentAnimation !== previousState.currentAnimation) {
        if (!currentState.currentAnimation) {
          currentState.animationAudios[0]?.pause();
          operateAnimation(
            'PAUSE',
            useLayersStore.getState().animations,
            null,
            null,
            'AUTO',
            1,
            function () {},
            false
          );
        } else {
          useLayersStore.getState().setAnnotationsEnabled(false);
          currentState.animationAudios[0]?.play();
          operateAnimation(
            'PAUSE',
            useLayersStore.getState().animations,
            null,
            null,
            'AUTO',
            1,
            function () {},
            false
          );
          operateAnimation(
            'PLAY',
            useLayersStore.getState().animations,
            currentState.currentAnimation?.start || null,
            currentState.currentAnimation?.end || null,
            'LoopRepeat',
            1,
            function () {},
            false
          );
        }
      }
      if (currentState.annotationsEnabled && !previousState.annotationsEnabled) {
        currentState.animationAudios[0]?.pause();
        if (currentState.animationAudios[0]) currentState.animationAudios[0].currentTime = 0;
        operateAnimation(
          'PAUSE',
          useLayersStore.getState().animations,
          null,
          null,
          'AUTO',
          1,
          function () {},
          false
        );
        operateAnimation(
          'PLAY',
          useLayersStore.getState().animations,
          1,
          1,
          'AUTO',
          1,
          function () {},
          false
        );
      }
    }
  );

  var initAnimationMixer = (function () {
    function onMixerFinished(e) {
      var cb = _pGlob.animMixerCallbacks;
      var found = [];
      for (var i = 0; i < cb.length; i++) {
        if (cb[i][0] == e.action) {
          cb[i][0] = null; // desactivate
          found.push(cb[i][1]);
        }
      }
      for (var i = 0; i < found.length; i++) {
        found[i]();
      }
    }

    return function initAnimationMixer() {
      if (v3dApp.mixer && !v3dApp.mixer.hasEventListener('finished', onMixerFinished)) {
        v3dApp.mixer.addEventListener('finished', onMixerFinished);
      }
    };
  })();

  function operateAnimation(operation, animations, from, to, loop, speed, callback, rev) {
    if (!animations) return;
    // input can be either single obj or array of objects
    if (typeof animations == 'string') animations = [animations];

    function processAnimation(animName) {
      function getSceneByAction(action) {
        var root = action.getRoot();
        var scene = root.type == 'Scene' ? root : null;
        root.traverseAncestors(function (ancObj) {
          if (ancObj.type == 'Scene') {
            scene = ancObj;
          }
        });
        return scene;
      }
      function getSceneAnimFrameRate(scene) {
        if (scene && 'animFrameRate' in scene.userData) {
          return scene.userData.animFrameRate;
        }
        return 24;
      }
      var action = v3d.SceneUtils.getAnimationActionByName(v3dApp, animName);
      if (!action) return;
      switch (operation) {
        case 'PLAY':
          if (!action.isRunning()) {
            action.reset();
            if (loop && loop != 'AUTO') action.loop = v3d[loop];
            var scene = getSceneByAction(action);
            var frameRate = getSceneAnimFrameRate(scene);

            action.repetitions = Infinity;

            var timeScale = Math.abs(parseFloat(speed));
            if (rev) timeScale *= -1;

            action.timeScale = timeScale;
            action.timeStart = from !== null ? from / frameRate : 0;
            if (to !== null) {
              action.getClip().duration = to / frameRate;
            } else {
              action.getClip().resetDuration();
            }
            action.time = timeScale >= 0 ? action.timeStart : action.getClip().duration;

            action.paused = false;
            action.play();

            // push unique callbacks only
            // var callbacks = _pGlob.animMixerCallbacks;
            // var found = false;

            // for (var j = 0; j < callbacks.length; j++)
            //     if (callbacks[j][0] == action && callbacks[j][1] == callback)
            //         found = true;

            // if (!found)
            //     _pGlob.animMixerCallbacks.push([action, callback]);
          }
          break;
        case 'STOP':
          action.stop();

          // remove callbacks
          var callbacks = _pGlob.animMixerCallbacks;
          for (var j = 0; j < callbacks.length; j++)
            if (callbacks[j][0] == action) {
              callbacks.splice(j, 1);
              j--;
            }

          break;
        case 'PAUSE':
          action.paused = true;
          break;
        case 'RESUME':
          action.paused = false;
          break;
        case 'SET_FRAME':
          var scene = getSceneByAction(action);
          var frameRate = getSceneAnimFrameRate(scene);
          action.time = from ? from / frameRate : 0;
          action.play();
          action.paused = true;
          break;
        case 'SET_SPEED':
          var timeScale = parseFloat(speed);
          action.timeScale = rev ? -timeScale : timeScale;
          break;
      }
    }

    for (var i = 0; i < animations.length; i++) {
      var animName = animations[i];
      if (animName) processAnimation(animName);
    }

    initAnimationMixer();
  }

  let morphingDisabled = false;

  function disableMorphing() {
    if (morphingDisabled) return;
    morphingDisabled = true;
    v3dApp.scene.traverse(function (obj) {
      if (!obj.geometry || !obj.geometry.morphAttributes) {
        return;
      }
      obj.geometry.morphAttributesTemp = obj.geometry.morphAttributes;
      obj.geometry.morphAttributes = {};
      obj.geometry.computeBoundsTree();
    });
  }

  function enableMorphing() {
    if (!morphingDisabled) return;
    morphingDisabled = false;
    v3dApp.scene.traverse(function (obj) {
      if (!obj.geometry || !obj.geometry.morphAttributes) {
        return;
      }
      obj.geometry.morphAttributes = obj.geometry.morphAttributesTemp;
      obj.geometry.computeBoundsTree();
    });
  }

  // Add this new function
  function setupAnnotations(scene) {
    // disableMorphing()
    const root = createRoot(annotationContainer);
    const raycaster = new v3d.Raycaster();
    let previousAnnotations = []; // Store previous annotations
    const updateAnnotations = () => {
      const annotations = [];
      const currentLayer = useLayersStore.getState().activeLayerIndex;
      const annotationsEnabled = useLayersStore.getState().annotationsEnabled;
      const featureEnabled = useLayersStore.getState().featureEnabled;

      if (!annotationsEnabled || !featureEnabled.labels) {
        enableMorphing();
        flushSync(() => {
          root.render(<React.Fragment />);
        });
        return;
      } else {
        disableMorphing();
      }

      scene.traverse(obj => {
        const objName = obj.name.split('__')[0];
        if (annoConfig[objName]) {
          // Check if object belongs to current layer
          const groupNames = obj.groupNames || [];
          let isInCurrentLayer = false;

          if (biocloudGeneratorConfig.layers) {
            for (let i = 0; i < groupNames.length; i++) {
              const groupName = groupNames[i];
              if (!groupName.includes('Group_')) return;
              const groupNumber = parseInt(groupName.replace('Group_', ''));

              if (groupNumber === currentLayer + 1) {
                isInCurrentLayer = true;
              }
            }
          } else {
            isInCurrentLayer = true;
          }
          // Only process annotation if object is in current layer
          if (isInCurrentLayer) {
            const worldPos = new v3d.Vector3();
            obj.getWorldPosition(worldPos);

            const directionToCamera = new v3d.Vector3()
              .subVectors(v3dApp.camera.position, worldPos)
              .normalize();
            raycaster.set(worldPos, directionToCamera);
            const intersects = raycaster.intersectObjects(scene.children, true);

            const visible = intersects.length === 0 || intersects[0].object.name === obj.name;

            const screenPos = worldPos.project(v3dApp.camera);
            const x = ((screenPos.x + 1) * window.innerWidth) / 2;
            const y = ((-screenPos.y + 1) * window.innerHeight) / 2;

            const [title, description] = annoConfig[objName];
            annotations.push({
              key: obj.name,
              x,
              y,
              title,
              description,
              visible,
            });
          }
        }
      });

      // Only render if annotations have changed
      if (JSON.stringify(annotations) !== JSON.stringify(previousAnnotations)) {
        flushSync(() => {
          root.render(
            <React.Fragment>
              {annotations.map(anno => (
                <Annotation
                  id={anno.key}
                  key={anno.key}
                  x={anno.x}
                  y={anno.y}
                  title={anno.title}
                  description={anno.description}
                  visible={anno.visible}
                />
              ))}
            </React.Fragment>
          );
        });
        previousAnnotations = annotations; // Update previous annotations
      }

      useLayersStore
        .getState()
        .setAnnotations(
          annotations.map(({ title, description, key }) => ({ title, description, id: key }))
        );
    };
    updateAnnotations();
    const originalRender = v3dApp.renderer.render.bind(v3dApp.renderer);
    v3dApp.renderer.render = function (e, t) {
      const returnValue = originalRender(e, t);
      updateAnnotations();
      return returnValue;
    };
    window.addEventListener('resize', updateAnnotations);
    // v3dApp.addEventListener('beforeRender', updateAnnotations);
  }
}
